var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { TEMPLATE_LOOKUP } from '@/types';
import { getRootDomainIP, getSubDomainUrl } from '@/utility';
import { getCurrentInstance, inject, reactive, ref } from 'vue';
import { DomainConnectServices } from '@/service/DomainConnectService';
import { useI18n } from 'vue-i18n';
import { useEvent } from './useEvent';
export const useVerification = () => {
    const emitter = inject('emitter');
    const { t } = useI18n();
    const isErrorVerifyingDomain = reactive({ state: false, errorMessage: '' });
    const isLoading = ref(false);
    const route = inject('route');
    const componentInstance = getCurrentInstance();
    const { delay } = useEvent();
    const verifyAndAttachedSsl = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        yield delay(20 * 1000); // 20sec delay
        try {
            const { data } = yield DomainConnectServices.migrateDNSRecords({
                domain: payload.template === TEMPLATE_LOOKUP.cname
                    ? `${payload.subdomain}.${payload.domain}`
                    : payload.domain,
                productArea: payload.team,
                template: payload.template,
                locationId: (_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.location_id,
            });
            if (data.success) {
                isErrorVerifyingDomain.state = false;
                isErrorVerifyingDomain.errorMessage = '';
                emitter.emit('onMigrateSuccessfully');
                componentInstance.emit('closeModal');
            }
            else {
                isErrorVerifyingDomain.state = true;
                isErrorVerifyingDomain.errorMessage = payload.subdomain
                    ? t('cNameNotFound', { cnameURL: getSubDomainUrl(payload.team) })
                    : t('apexNotFound', { apexIP: getRootDomainIP(payload.team) });
            }
        }
        catch (err) {
            isErrorVerifyingDomain.state = true;
            isErrorVerifyingDomain.errorMessage = '';
            console.error(err);
        }
        finally {
            isLoading.value = false;
        }
    });
    const onAuthorized = (payload, isMigrating) => {
        isLoading.value = true;
        isErrorVerifyingDomain.state = false;
        isErrorVerifyingDomain.errorMessage = '';
        if (isMigrating) {
            verifyAndAttachedSsl(payload);
        }
        else {
            emitter.emit('onSendDomainConnectPayload', payload);
        }
    };
    const onReceivedConfirmation = (payload) => {
        var _a;
        if (payload.flag) {
            isLoading.value = false;
            isErrorVerifyingDomain.state = false;
            isErrorVerifyingDomain.errorMessage = undefined;
        }
        else {
            isLoading.value = false;
            isErrorVerifyingDomain.state = true;
            isErrorVerifyingDomain.errorMessage = (_a = payload.errorMessage) !== null && _a !== void 0 ? _a : '';
        }
    };
    return {
        onAuthorized,
        onReceivedConfirmation,
        isErrorVerifyingDomain,
        isLoading,
    };
};
